<template>
    <div class="ppv2-flex ppv2-p-1">
        <button
            v-for="item in types"
            :key="item.value"
            :disabled="item.disabled"
            @click="!item.disabled && $emit('update:type', item.value)"
            class="ppv2-flex-1 ppv2-h-[40px] ppv2-text-sm poppinsMedium ppv2-transition-all ppv2-rounded-lg ppv2-relative ppv2-flex ppv2-items-center ppv2-justify-center"
            :class="[
                item.disabled
                    ? 'ppv2-text-black ppv2-text-opacity-70 ppv2-cursor-not-allowed'
                    : type === item.value
                      ? 'ppv2-bg-[#7C3AED] ppv2-text-white ppv2-shadow-sm'
                      : 'ppv2-text-black ppv2-text-opacity-70 hover:ppv2-bg-opacity-20 hover:ppv2-bg-white',
            ]"
        >
            {{ item.label }}
            <span
                v-if="item.disabled"
                class="ppv2-absolute ppv2-top-0.5 ppv2-right-1 ppv2-text-[9px] ppv2-text-gray-300 ppv2-leading-none poppinsRegular"
                :title="$t('staff_planning_v3.components.planning_type_selector.min_weeks_hint')"
            >
                ({{ item.hint }})
            </span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        type: String,
        weekStr: String,
        canShowMonth: {
            type: Boolean,
            default: true,
        },
        enabledWeeksMonthCount: {
            type: Number,
            default: 0,
        },
        enabledWeeksPersoCount: {
            type: Number,
            default: 0,
        },
        selectedWeek: {
            type: String,
            default: '',
        },
    },

    computed: {
        types() {
            const base = [
                {
                    value: 'week',
                    label: this.$t('staff_planning_v3.components.planning_type_selector.week', {
                        week: this.selectedWeek.split('-W')[1],
                    }),
                    disabled: false,
                },
                {
                    value: 'month',
                    label: this.$t('staff_planning_v3.components.planning_type_selector.month'),
                    disabled: !this.canShowMonth || this.enabledWeeksMonthCount < 2,
                    hint: this.$t('staff_planning_v3.components.planning_type_selector.min_hint'),
                },
                {
                    value: 'custom',
                    label: this.$t('staff_planning_v3.components.planning_type_selector.personalized'),
                    disabled: this.enabledWeeksPersoCount < 2,
                    hint: this.$t('staff_planning_v3.components.planning_type_selector.min_hint'),
                },
            ]

            return base
        },
    },
}
</script>
